// Bài hướng dẫn trang Suất buổi 5 tiếng — /half-day-slots.
//
// ⚠️ Ranh giới thông tin ở `../types.ts` áp NGUYÊN VẸN: không ghi cách tính công.

import type { GuideBook } from "../types";

export const HALF_DAY_SLOT_GUIDES: GuideBook = {
  half_day_slots: {
    purpose: "Nơi cơ sở mở suất chụp 5 tiếng của gói Một Buổi Xinh Trọn Vẹn và theo dõi suất đã bán.",
    where: [
      'Nút "Mở suất" ở góc trên: mở hộp chọn ngày, thợ chụp, thợ trang điểm. Chỉ người xếp lịch cơ sở mới thấy nút này.',
      'Hai ô đầu trang "Đang mở" và "Đã bán" đếm suất từ tuần này trở đi; dòng chữ phía trên cho biết tuần này đã mở bao nhiêu suất.',
      'Mỗi dòng là một suất: ngày, giờ, hai thợ, mã đơn nếu đã bán. Cuối dòng có nhãn tình trạng và các nút "Đổi thợ", "Đóng suất", "Mở đơn".',
      'Cuối trang, người được xem số có khối "Kết quả theo tuần": số suất mở, số suất bán, doanh thu, giờ thêm và số đơn mua từ 2 set.',
    ],
    howItWorks: [
      "Quầy và kinh doanh chỉ bán được suất đang mở: chọn gói Một Buổi Xinh Trọn Vẹn ở màn tạo đơn thì màn hiện danh sách suất để chọn.",
      "Đơn nhận ngày, giờ và hai thợ theo suất. Muốn đổi lịch, mở đơn và bấm \"Đổi sang suất khác\"; mỗi đơn đổi được một lần.",
      "Hủy đơn thì suất tự mở lại cho khách khác. Đơn đã hủy không khôi phục được, phải tạo đơn mới.",
      "Thợ đã nhận suất được giữ chỗ trong giờ đó, nên không bị xếp thêm đơn trùng giờ, kể cả suất ở cơ sở khác.",
      "Suất đã qua ngày chụp không bán được và không đổi sang được, kể cả khi chưa ai đóng.",
      "Khách chốt concept trước buổi chụp ít nhất 3 ngày, ở nút \"Chốt concept\" trên trang đơn. Tại chỗ không đổi.",
    ],
    statuses: [
      { label: "Đang mở", meaning: "Suất đã có đủ thợ, quầy bán được." },
      { label: "Đã bán", meaning: "Suất đã gắn với một đơn. Bấm \"Mở đơn\" để xem." },
    ],
    blocks: [
      {
        for: ["lead", "exec"],
        title: "Việc của người xếp lịch cơ sở",
        steps: [
          "Hỏi trước thợ chụp và thợ trang điểm có nhận buổi không.",
          'Bấm "Mở suất", chọn ngày, chọn hai thợ, bấm "Xác nhận mở suất".',
          'Suất chưa ai mua mà không còn cần: bấm "Đóng suất".',
          'Thợ nghỉ đột xuất: bấm "Đổi thợ" ở dòng suất đó. Suất đã bán thì đơn đổi thợ theo.',
        ],
        troubles: [
          "Màn báo chỉ mở vào một số ngày trong tuần, hay đã đủ số suất của ngày hoặc tuần → chọn ngày khác.",
          "Tên thợ hiện \"đã có việc giờ này\" → thợ đó đã có đơn hoặc suất khác trùng giờ, chọn người khác.",
          "Không đóng được suất đã bán → hủy đơn trước, suất sẽ mở lại rồi mới đóng được.",
          "Màn báo \"Suất vừa được bán, không đóng được\" → quầy vừa bán suất đó ngay lúc bạn bấm. Tải lại trang để thấy đơn.",
        ],
      },
      {
        for: ["sale", "reception"],
        title: "Việc của quầy và kinh doanh",
        steps: [
          "Mở trang này để xem còn suất nào, báo khách ngày giờ.",
          "Ở màn tạo đơn, chọn gói Một Buổi Xinh Trọn Vẹn, chọn chi nhánh, chọn suất.",
          "Thu cọc theo số màn đã điền sẵn. Gói này không áp dụng mã giảm.",
          'Sau khi có đơn, mở đơn và bấm "Chốt concept" để ghi 3 đến 5 concept khách chọn.',
        ],
        troubles: [
          "Không thấy suất nào → báo quản lý trực tiếp để mở suất.",
          "Màn báo suất đã được bán → người khác vừa bán xong, chọn suất khác.",
          "Màn báo suất đã qua ngày chụp → suất cũ chưa ai đóng, không bán và không đổi sang được. Chọn suất từ hôm nay trở đi.",
          "Không sửa được giờ hay thợ trên đơn, hoặc nút Hoãn báo không hoãn được → đây là đơn theo suất, dùng \"Đổi sang suất khác\".",
        ],
      },
    ],
  },
};
